import React, { useEffect, useState } from "react";
import { similarMaster } from "./masterHsApi";

/** 상세 슬라이드인의 "유사 이력" 섹션 — top-5(일치율 내림차순) + 행별 [이 세번 적용]. */
export default function SimilarHistorySection({ keyword, onApply }) {
  const [items, setItems] = useState(null); // null=로딩

  useEffect(() => {
    let alive = true;
    setItems(null);
    similarMaster(keyword, 5).then((d) => {
      if (alive) setItems(d.error ? { error: true } : d.items || []);
    });
    return () => {
      alive = false;
    };
  }, [keyword]);

  if (items == null)
    return (
      <div style={{ marginTop: 12, color: "#6b7280", fontSize: 12 }}>
        유사 이력 조회 중…
      </div>
    );
  if (items.error)
    return (
      <div style={{ marginTop: 12, color: "#6b7280", fontSize: 12 }}>
        유사 이력을 불러오지 못했습니다.
      </div>
    );
  if (!items.length) return null;

  const td = { border: "1px solid #e5e7eb", padding: "3px 8px" };
  return (
    <div style={{ marginTop: 12 }}>
      <b>유사 이력</b>
      <table
        style={{
          fontSize: 12,
          borderCollapse: "collapse",
          marginTop: 6,
          width: "100%",
        }}
      >
        <thead>
          <tr>
            <th style={td}>일치율</th>
            <th style={td}>세번</th>
            <th style={td}>상품명</th>
            <th style={td}>공급자</th>
            <th style={td}></th>
          </tr>
        </thead>
        <tbody>
          {items.map((it, i) => (
            <tr key={i}>
              <td style={{ ...td, fontWeight: it.rate >= 90 ? 700 : 400 }}>
                {it.rate}%
              </td>
              <td style={{ ...td, fontFamily: "monospace" }}>{it.hsk}</td>
              <td style={td}>{it.productName || it.keyword}</td>
              <td style={td}>{it.supplier || ""}</td>
              <td style={td}>
                <button
                  onClick={() => onApply && onApply(it.hsk)}
                  style={{
                    fontSize: 11,
                    padding: "1px 8px",
                    cursor: "pointer",
                  }}
                >
                  이 세번 적용
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
